module.exports = __webpack_public_path__ + "static/media/VestasSans-Extrabold.84983e9f.woff";